import { module } from 'modujs';
import gsap from 'gsap';
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(SplitText);

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        document.fonts.ready.then(() => {
            let splitType = (this.el.getAttribute('data-split-type')) ? this.el.getAttribute('data-split-type') : 'lines';
            // let selector = (this.el.querySelectorAll('p').length > 0) ? this.el.querySelectorAll('p') : this.el;
            let selector = this.el;
            let mask = (this.el.getAttribute('data-split-mask')) ? this.el.getAttribute('data-split-mask') : null;
            let propIndex = (this.el.getAttribute('data-split-index') && this.el.getAttribute('data-split-index') === 'true');
            this.split = SplitText.create(selector, {
                type: splitType,
                linesClass: "line",
                wordsClass: "word",
                charsClass: "char",
                autoSplit: true,
                propIndex: propIndex,
                mask: mask,
            });
        });
    }
}
